// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3VqXN","notes":"Notes_notes__1C4zw","note":"Notes_note__2ovnQ","markdown":"Notes_markdown__3qA6b"};